export default {
  "depositRecord.title": "Deposit Records",
  "depositRecord.action.details": "Details",
  "depositRecord.action.export": "Export User List",
  "depositRecord.copy.success": "Copied to clipboard",
  "depositRecord.tooltip.copy.userNo": "Copy UserNo: {text}",
  "depositRecord.tooltip.copy.orderNo": "Copy OrderNo: {text}",
  "depositRecord.tooltip.copy.merOrderNo": "Copy MerOrderNo: {text}",
  "depositRecord.tooltip.showUserDetails": "Show User Details",
  "depositRecord.modal.title.details": "Details",
  "depositRecord.modal.title.userDetails": "User Details",
  "depositRecord.modal.title.exportList": "Export List",
  "depositRecord.column.no": "#NO",
  "depositRecord.column.orderNo": "OrderNo",
  "depositRecord.column.merOrderNo": "MerOrderNo",
  "depositRecord.column.userNo": "UserNo",
  "depositRecord.column.whatsapp": "Whatsapp",
  "depositRecord.column.email": "Email",
  "depositRecord.column.amount": "Amount(R$)",
  "depositRecord.column.platform": "Platform",
  "depositRecord.column.bonusTitle": "Bonus Title",
  "depositRecord.column.bonus": "Bonus",
  "depositRecord.column.rollover": "Rollover",
  "depositRecord.column.returnDays": "Return Days",
  "depositRecord.column.alreadyReturnDays": "Already Return Days",
  "depositRecord.column.orderStatus": "Order Status",
  "depositRecord.column.firstName": "First Name",
  "depositRecord.column.lastName": "Last Name",
  "depositRecord.column.nickName": "Nick Name",
  "depositRecord.column.source": "Source",
  "depositRecord.column.channel": "Channel",
  "depositRecord.column.cpf": "CPF",
  "depositRecord.column.accountName": "Account Name",
  "depositRecord.column.createTime": "Create Time",
  "depositRecord.column.registerTime": "Register Time",
  "depositRecord.column.action": "Action",
  "depositRecord.search.createTime": "Create Time",
  "depositRecord.search.userNo": "UserNo",
  "depositRecord.search.orderNo": "OrderNo",
  "depositRecord.search.merOrderNo": "MerOrderNo",
  "depositRecord.search.channel": "Channel",
  "depositRecord.search.orderStatus": "Order Status",
  "depositRecord.search.platform": "Platform",
  "depositRecord.search.bonus": "Bonus",
  "depositRecord.search.amount": "Amount",
  "depositRecord.search.orderTimes": "Order Times",
  "depositRecord.search.source": "Source",
  "depositRecord.search.whatsapp": "Whatsapp",
  "depositRecord.export.title": "Email Title",
  "depositRecord.export.content": "Email Content",
  "depositRecord.export.email": "Email",
  "depositRecord.export.title.default": "DepositAdminExport",
  "depositRecord.export.content.default": "Deposit admin file",
};